import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link, useParams } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { ArrowLeft } from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function BlogPostPage() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    axios
      .get(`${API}/blog/${slug}`)
      .then((r) => setPost(r.data))
      .catch(() => setNotFound(true));
  }, [slug]);

  return (
    <>
      <Navbar />
      <main data-testid="blog-post-page" className="pt-32 lg:pt-40 pb-24 bg-[#FAF9F6]">
        <article className="mx-auto max-w-3xl px-6 lg:px-12">
          <Link to="/blog" className="inline-flex items-center gap-2 text-sm text-[#5C605A] hover:text-[#B35B47]">
            <ArrowLeft className="h-4 w-4" /> Back to journal
          </Link>

          {notFound && (
            <div className="mt-10 font-serif text-2xl text-[#2C302E]">This story has drifted away.</div>
          )}

          {post && (
            <>
              <div className="mt-8 flex items-center gap-3 text-xs uppercase tracking-[0.22em] text-[#8A8D86]">
                <span className="text-[#B35B47]">{post.tag}</span><span>·</span><span>{post.read_time}</span><span>·</span><span>{post.author}</span>
              </div>
              <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl mt-5 text-[#2C302E] leading-[1.05]">
                {post.title}
              </h1>
              <div className="mt-10 aspect-[16/9] rounded-2xl overflow-hidden">
                <img src={post.cover_image} alt={post.title} className="h-full w-full object-cover" />
              </div>
              <div className="prose prose-lg max-w-none mt-10 font-[Outfit] text-[#2C302E] leading-relaxed text-lg whitespace-pre-line">
                {post.body}
              </div>
            </>
          )}
        </article>
      </main>
      <Footer />
    </>
  );
}
